import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ShippingType } from 'src/app/shared-lib/core/settings';
import { PostalAddress } from 'src/app/shared-lib/global/models';
import { OrderService } from '../../shared/order.service';
import { AddressComponent } from './address/address.component';

@Component({
  selector: 'app-address-container',
  templateUrl: './address-container.component.html',
  styleUrls: ['./address-container.component.scss'],
  standalone: false
})
export class AddressContainerComponent implements OnInit {
  addressComponent = AddressComponent; //-- con esto el modal lo llevara al componente address

  form: UntypedFormGroup = null; //--> aqui esta el formulario en su ultimo estado
  addressSelected: string = null; //--> aqui esta a cual address estamos cambiando
  writeAddress: boolean = false; //--> si estamos escribiendo una nueva direccion
  showClearButton = true;
  orderId = null;
  thereIsPoint;
  addresses = [] as PostalAddress[];
  defaultAddressIndex: number;
  onPickUpPointSelection: boolean = false;
  shippingType: ShippingType;
  editMode: boolean = false;
  billingSameAsShipping: boolean = false;

  constructor(private orderService: OrderService) {
  }

  ngOnInit() {
    if (!this.form) {
      console.log('Address ERROR, no encontró el form: ', this.addressSelected);// vemos a cual nos fuimos..
    }

  }

}
